module.exports = __webpack_public_path__ + "img/podcast-icon.98bdd116.png";